import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import api from "../../../../../Services/api";
import theme from "../../../../../Styles/theme";
import { ModalDivX } from "../../../../ModalDivX";
import { ModalLoader } from "../../../../ModalLoader";
import { HandleCentralize, TipoButton } from "./styles";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

export interface ITipoNaoTributado {
  ID: number;
  TITULO: string;
}

interface Props {
  tipo_focus: ITipoNaoTributado;
  open: boolean;
  onClose(): void;
  handleSetTipo(tipo: ITipoNaoTributado): void;
}

export function ModalTipoNaoTributado({
  open,
  onClose,
  handleSetTipo,
  tipo_focus,
}: Props) {
  const [tipos_tributacao, settipos_tributacao] = useState(
    {} as ITipoNaoTributado[]
  );
  const [loading, setLoading] = useState(false);

  async function handleGetData() {
    setLoading(true);
    try {
      const { data } = await api.get(`/tipos-tributacao`);
      settipos_tributacao(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  function listTiposOperacoes() {
    if (tipos_tributacao) {
      if (tipos_tributacao.length > 0) {
        return tipos_tributacao.map((item) => {
          return (
            <HandleCentralize>
              {" "}
              <TipoButton
                focus={(tipo_focus.ID == item.ID)}
                onClick={() => {
                  handleSetTipo(item);
                  onClose();
                }}
              >
                {item.TITULO}
              </TipoButton>
            </HandleCentralize>
          );
        });
      }
    }
  }

  useEffect(() => {
    handleGetData();
  }, []);
  return (
    <Modal isOpen={open} onRequestClose={() => {}} style={customStyles}>
      <ModalDivX execute={onClose} />
      {listTiposOperacoes()}
      <ModalLoader loading={loading} />
    </Modal>
  );
}
